import * as React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Container, Typography, Box } from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AllNftdetails from './AllNftdetails';
import Art from './Art';
import { API_URL } from '../../Config';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';


const ExDetails = () => {
    const [category,setcategorydata] = useState([]);
    const [fetchdata,setfetchedata] =useState([]);
    const [value, setValue] = React.useState('All');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const categorydata = async () => {
        await axios
        .post(`${API_URL}/indexData.php?type=category`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(async (req) => {
           if (req.data) {
            setcategorydata(req.data);
            }
        })
        .catch((res) => {
          
        });
    };


    const fetchcatedata = async (type) => {
        await axios
        .post(`${API_URL}/fetchCategory.php?type=category&category=${type}`, {
            headers: {
            "Content-Type": "application/json",
            },
        })
        .then(async (req) => {
          if (req.data) {
            setfetchedata(req.data);
            }
        })
        
    };


    useEffect(() => {
        if(category.length == 0){
            categorydata();
            fetchcatedata("All");
        }
    
      }, [category]);


    return (
        <>

            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Explore
                    </Typography>
                </Box>
            </Box>
            <Box className='tab_one' marginY={'3rem'}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <Container maxWidth='xl'>
                        {/* <Typography variant='h2' fontSize='45px' fontWeight='bold' paddingBottom='20px'>  Explore NFTs </Typography> */}
                        <TabContext value={value}>
                            <Box className='select_btns'>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="All NFTs" value="All"  onClick={()=>fetchcatedata("All")}/>
                                    {category && category.map((cat,index)=>(
                                        <Tab key={cat.id} label={cat.category_name} value={cat.category_name} onClick={()=>fetchcatedata(cat.category_name)}/>
                                    ))}
                                </TabList>
                            </Box>
                            <TabPanel value="All" className='sathsmunder'>
                                <AllNftdetails fetchdata={fetchdata}/>
                            </TabPanel>
                            {category && category.map((cat,index)=>(
                                <TabPanel key={index} value={cat.category_name} className={`btn ${cat.category_name ? "active" : ""
                            } d-table text-uppercase p-2 sathsmunder`} >
                                <Art fetchdata ={fetchdata}/>
                            </TabPanel>
                            ))}
                         </TabContext>
                    </Container>
                </Box>
            </Box>
        </>
    )
}

export default ExDetails;